import { render, staticRenderFns } from "./ValidacaoOcorrencia.vue?vue&type=template&id=0828a4d0&scoped=true"
import script from "./ValidacaoOcorrencia.vue?vue&type=script&lang=js"
export * from "./ValidacaoOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ValidacaoOcorrencia.vue?vue&type=style&index=0&id=0828a4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828a4d0",
  null
  
)

export default component.exports